import React from "react";
import Navbar from "../components/Navbar";

const TermsPage = () => {
  return (
    <div className="min-h-screen bg-[#050505] text-white">
      <Navbar />

      <div className="max-w-4xl mx-auto px-6 py-20">
        <h1 className="text-4xl text-[#FFD700] font-['Cinzel'] mb-10">
          Terms & Conditions
        </h1>

        <div className="space-y-6 text-gray-300 leading-relaxed">
          <p>
            By using TopNationApp, you agree to the following terms and conditions.
          </p>

          <p>
            TopNationApp is an interactive global bidding and ranking platform
            where users may place bids on countries displayed on the world map.
          </p>

          <p>
            By placing a bid, the user voluntarily chooses to display their public
            profile name, company name, website, or custom display name up to 25
            characters on the platform.
          </p>

          <p>
            The purpose of this platform is to display public profiles and user
            rankings based on bidding activity. Rankings are visible to all users
            and are part of the competitive leaderboard system.
          </p>

          <p>
            The highest bidder for a country becomes the top-ranked participant
            for that country on the platform until another user places a higher bid.
          </p>

          <p>
            TopNationApp is a symbolic digital platform designed for entertainment,
            public ranking, and competitive participation.
          </p>

          <p>
            Winning a bid for a country on the platform does not grant any real-world
            ownership, legal rights, territorial rights, governmental authority,
            or any form of control over the actual country.
          </p>

          <p>
            The displayed country position represents only a symbolic digital status
            within the TopNationApp platform.
          </p>

          <p>
            Users participate in a competitive bidding system where their selected
            public profile information may appear on rankings, country pages, and
            leaderboard areas of the platform.
          </p>

          <p>
            All bids placed on TopNationApp represent participation in a competitive
            digital ranking system.
          </p>

          <p>
            Once a bid payment has been successfully processed through the payment
            provider, the transaction is considered final and non-refundable.
          </p>

          <p>
            TopNationApp is a competitive ranking platform and does not sell
            advertising services or sponsored placements.
          </p>

          <p>
            By placing a bid you confirm that:
          </p>

          <ul className="list-disc ml-6 space-y-2">
            <li>You agree to these Terms & Conditions.</li>
            <li>You understand that bids are competitive.</li>
            <li>You understand that another user may outbid you.</li>
            <li>Your selected public profile information may be visible.</li>
            <li>The bid payment is final and non-refundable.</li>
            <li>The displayed country position is symbolic and digital only.</li>
          </ul>

          <p>
            TopNationApp reserves the right to remove inappropriate content,
            offensive names, or misuse of the platform.
          </p>
        </div>
      </div>
    </div>
  );
};

export default TermsPage;
